/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Sets_Nav_LabelInputs */



/**
* | output |
* | --- |
* | "Tag sets" |
*
* @param {Tags_Manager_Sets_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_sets_nav_label = /** @type {((inputs?: Tags_Manager_Sets_Nav_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Sets_Nav_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ensembles de tags")
	if (locale === "de") return /** @type {LocalizedString} */ ("Etikettensätze")
	if (locale === "it") return /** @type {LocalizedString} */ ("Set di tag")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Наборы тегов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conjuntos de etiquetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标签集")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग सेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conjuntos de etiquetas")
	return /** @type {LocalizedString} */ ("Tag sets")
});